import { useEffect, useState } from 'react';
import axios from 'axios';
import { hasHandicap } from '../utils/handicap';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Display the canonical server result; never recalculate an index in the header.
export const useHeaderHandicap = (userId, routeKey) => {
  const [state, setState] = useState({ userId: null, value: null, rounds: null, status: 'loading' });
  useEffect(() => {
    let active = true;
    let controller;
    if (!userId) return;
    const refresh = async () => {
      controller?.abort();
      const request = new AbortController();
      controller = request;
      setState(previous => previous.userId === userId ? { ...previous, status: 'loading' } : { userId, value: null, rounds: null, status: 'loading' });
      try {
        const { data } = await axios.get(`${API}/stats`, { signal: request.signal, timeout: 15000 });
        if (!active || request.signal.aborted) return;
        if (data?.handicap !== null && !hasHandicap(data?.handicap)) throw new Error('Invalid handicap response');
        setState({ userId, value: data.handicap, rounds: Number.isInteger(data.rounds_played) ? data.rounds_played : null, status: 'ready' });
      } catch (error) {
        if (active && !request.signal.aborted) setState({ userId, value: null, rounds: null, status: 'error' });
      }
    };
    refresh();
    window.addEventListener('focus', refresh);
    window.addEventListener('scoresUpdated', refresh);
    window.addEventListener('handicapUpdated', refresh);
    return () => {
      active = false;
      controller?.abort();
      window.removeEventListener('focus', refresh);
      window.removeEventListener('scoresUpdated', refresh);
      window.removeEventListener('handicapUpdated', refresh);
    };
  }, [userId, routeKey]);
  return state.userId === userId ? state : { value: null, rounds: null, status: 'loading' };
};